import {
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import React from 'react';

const useStyles = makeStyles(theme => ({
  navigationButtonsPhone: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    padding: theme.spacing(),
    zIndex: 99,
    background: 'white',
    paddingBottom: `env(safe-area-inset-bottom)`
  },
  navigationButtonsDesktop: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}));

export default function FinalButtons({
  activeStep,
  isPhone,
  loadingSendPre,
  handleBack,
  cancelText,
  okText,
  handleOk,
  isSubmitting
}) {
  const classes = useStyles();

  const getIcon = () => {
    if (isSubmitting || loadingSendPre) {
      return <CircularProgress size={20} />;
    }
    return <CheckIcon />;
  };

  return (
    <Container maxWidth="lg">
      <Grid
        container
        alignItems="flex-end"
        justifyContent="flex-end"
        // spacing={4}
        className={
          isPhone
            ? classes.navigationButtonsPhone
            : classes.navigationButtonsDesktop
        }
      >
        <Grid item>
          <Button
            onClick={handleBack}
            className={classes.backButton}
            size={isPhone ? 'small' : 'medium'}
            disabled={activeStep === 0}
            startIcon={<NavigateBeforeIcon />}
          >
            {cancelText}
          </Button>
        </Grid>
        {okText && (
          <>
            <Divider
              orientation="vertical"
              flexItem
              style={{ marginLeft: 20, marginRight: 20 }}
            />
            <Grid item>
              <>
                <Button
                  type="submit"
                  color="primary"
                  disabled={isSubmitting || loadingSendPre}
                  variant="contained"
                  startIcon={getIcon()}
                  onClick={() => {
                    if (handleOk) {
                      handleOk();
                    }
                  }}
                >
                  {okText}
                </Button>
              </>
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
}
